import { render, staticRenderFns } from "./create-testQuestion.vue?vue&type=template&id=68ad61b6&scoped=true&"
import script from "./create-testQuestion.vue?vue&type=script&lang=ts&"
export * from "./create-testQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./create-testQuestion.vue?vue&type=style&index=0&id=68ad61b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ad61b6",
  null
  
)

export default component.exports